module.exports = __webpack_public_path__ + "131f0bee88430aaf4503f3774d643c01.png";